<app-profile-header></app-profile-header>

<section class="body-section">
    <p-toast key="toastMsg"></p-toast>
    <div class="container">
        <main>
            <div class="bottom-container Transaction-table ">
                <div class="box transaction-box ">
                    <div class="header-container">
                        <h3 class="section-header">My Tournaments</h3>
                    </div>
                    <div class="tables-sectionss">
                        <p-table id="vdtnetable10" #dt [value]="matchList" [paginator]="true" [rows]="10"
                            [rowsPerPageOptions]="paginationOption" [lazy]="true" scrollHeight="auto"
                            scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                            [scrollable]="true" cellpadding="0" class="transaction-history" pageLinks="3" [showPageLinks]="true"
                            (onLazyLoad)="getMyTournamentList($event)" aria-describedby="vdtnetable10_info">
                            <ng-template pTemplate="header">
                                <tr>

                                    <th pSortableColumn="tournamentName"
                                        class="rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1" rowspan="1"
                                        colspan="1" style="color: black;background-color: white;">
                                        <div>Name
                                            <p-sortIcon field="tournamentName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="matchName" class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Categories
                                            <p-sortIcon field="matchName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="agegroupName" class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Age Group
                                            <p-sortIcon field="agegroupName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="entryFee" class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Entry Fees
                                            <p-sortIcon field="entryFee"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th pSortableColumn="lastdateofwithdraw" class="sorting_disabled" rowspan="1"
                                        colspan="1">
                                        <div>Last Withdrawal Date
                                            <p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="tournamentEndDate" class="sorting_disabled" rowspan="1"
                                        colspan="1">
                                        <div>End Date
                                            <p-sortIcon field="tournamentEndDate"></p-sortIcon>
                                        </div>
                                    </th>
                                    <!-- <th pSortableColumn="tournamentStatus" class="sorting_disabled" rowspan="1"
                                        colspan="1" >
                                        <div>Status
                                            <p-sortIcon field="tournamentStatus"></p-sortIcon>
                                        </div>
                                    </th> -->
                                    <th class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Action

                                        </div>
                                    </th>

                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-matchList>
                                <tr>
                                    <td>
                                        <span class="mobile-label-div">
                                          Tournament Name:
                                        </span>
                                        <a class="rin-type-label state-finished" style=" cursor: pointer;"
                                            pTooltip="{{matchList.tournamentName}}" tooltipPosition="bottom"
                                            (click)="onclickTournamentdetails(matchList.tournamentId)">
                                            <i class="bx bxs-tennis-ball" style="margin-right: 10px; "></i>
                                            {{matchList.tournamentName}}
                                        </a></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            Categories:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            {{matchList.matchName}}
                                        </span></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            Age Group:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                        
                                            {{matchList.ageGroupName}}
                                        </span></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            Entry Fees:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            ₹ {{matchList.entryFee}}
                                        </span></td>

                                    <td>
                                        <span class="mobile-label-div">
                                            Withdrawal Date:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            {{matchList.lastdateofwithdraw | date : 'dd-MM-yyyy'}}
                                        </span></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            End Date:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            {{matchList.tournamentEndDate | date : 'dd-MM-yyyy'}}
                                        </span></td>
                                    <!-- <td><span class="rin-type-label state-finished">
                                            {{matchList.tournamentStatus}}
                                        </span></td> -->
                                    <td>
                                        <div class="status-buttons" *ngIf="matchList.showWithdraw == true">
                                            <button class="btn btn-success"
                                                (click)="withdrawModal(matchList.id,matchList.tournamentName,matchList.matchName,matchList.ageGroupName)"
                                                id="withdrawal-btn"><span><i class="bx bx-exit"></i></span>
                                                Withdraw</button>
                                        </div>
                                        <!-- <div class="disableBtn status-buttons" *ngIf="matchList.showWithdraw == false"
                                            pTooltip="Review" tooltipPosition="top"> -->
                                            <!-- <button class="btn btn-success"
                                                (click)="withdrawModal(matchList.id,matchList.tournamentName,matchList.matchName,matchList.ageGroupName)"
                                                id="withdrawal-btn" disabled><span><i class="bx bx-exit"></i></span>
                                                Withdraw</button> -->
                                            <!-- <button class="btn btn-success review-btn" (click)="reviewModal(matchList)">
                                                <span>
                                                    <i class='bx bx-message-dots'></i>
                                                </span>
                                                Review
                                            </button>

                                        </div> -->
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    {{totalRecords }} My Tournaments
                                </div>
                            </ng-template>
                        </p-table>
                    </div>



                </div>
            </div>



        </main>
    </div>
</section>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdrawinfo"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '38rem' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw</h5>
                <div class="headings col-md-12">

                    <h6>{{tname}}</h6>


                    <div class="countdown-container">
                        <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
                        <div class="countdown-text">{{ countdown }}</div>
                        <br>

                    </div>
                    <div class="timer-alert">
                        Please wait
                    </div>
                    <p class="note">We are processing your request for a refund in the tournament category. Once the
                        refund
                        process is successfully completed, please check wallet Balance.</p>

                </div>

            </div>
        </div>
    </div>
</p-dialog>

<p-dialog id="widthdraw-confitmation" [(visible)]="WithdrawcnfModal"
    [breakpoints]="{ '960px': '75vw' , '768px': '100%'}" [style]="{ width: '38rem' }" [modal]="true" [draggable]="false"
    [resizable]="false">
    <!---test-->

    <div class="modal-dialog w-100 modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important; width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation
                </h5>
            </div>
            <div class="modal-body">

                <p>
                    Are you sure you want to withdraw from the tournament? Please note that this action cannot be
                    undone, and your participation in the tournament will be cancelled.
                </p>


                <div class="add-even col-md-12">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">{{tname}}</div>
                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">{{mtn}}</span>
                                            <p>{{agn}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                    <p>
                        After the withdrawal, the entry fee amount will be credited back to your TPL wallet.
                    </p>


                    <!-- <div class="add-btn col-md-12">
  <button> Add Another Event <i class='bx bx-plus'></i> </button>
</div> -->

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
                    withdrawal</button>
            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentthankadmin" [(visible)]="thankwithdraw"
    [breakpoints]="{ '960px': '75vw', '768px': '100%' }" [style]="{ width: '500px' }" [modal]="true" [draggable]="false"
    [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw</h5>
                <div class="headings col-md-12">
                    <h6></h6>
                    <p class="note">Your Tournament withdrawals have been successfully processed.</p>
                </div>

            </div>

        </div>


    </div>

</p-dialog>

<p-dialog header="Write Your Review " [(visible)]="reviewModalPopup"
    [breakpoints]="{'960px': '75vw', '768px': 'calc(100% - 30px)'}" [draggable]="false" [style]="{width: '500px'}"
    [modal]="true" id="review-modal">
    <div class="rating-div">
        <div class="icons-acadmemy">
            <img src="{{academyDetails?.academypic}}"
                alt="">
        </div>
        <div class="rating-body">
            <div class="rating-heading col-md-12 mt-3">
                <h4>Please Provide Feedback</h4>
                <p class="note-acadmey">
                    What are your thoughts on your tournament experience with <span class="acName">{{academyDetails?.name}}
                        ?</span>
                </p>
            </div>
            <div class="rating-div-star col-md-12">
                <p-rating [(ngModel)]="rating" iconOnClass="pi pi-star-fill" (onRate)="onSelectRating()"
                    iconOffClass="pi pi-star"></p-rating>
            </div>
            <div  *ngIf="showRatingError" class="m-3">
                <span class="text-danger">Please select rating.</span>
            </div>
        </div>
    </div>
    <form *ngIf="reviewForm" [formGroup]="reviewForm" (ngSubmit)="onReviewSubmit()">
        <div class="comment-form col-md-12">
            <h5>Please share your opinions on the competition. </h5>
            <textarea [rows]="5" pInputTextarea formControlName="comments" placeholder="Write a review" class="w-100"
                [ngClass]="{'is-invalid':  ((submitted && f.comments.errors) || (f.comments.errors && (f.comments.dirty || f.comments.touched)))}"></textarea>
            <div *ngIf=" ((submitted && f.comments.errors) || (f.comments.errors && (f.comments.dirty || f.comments.touched)))"
                class="invalid-feedback">
                <div *ngIf="f.comments.errors.required">
                    Reviews are required.
                </div>
            </div>
        </div>
        <div class="col-md-12 reviews-button-footer">
            <button pButton class="review-btn">
                Submit Review
            </button>
        </div>
    </form>
</p-dialog>